import { createFileRoute } from '@tanstack/react-router'
import { JobTemplatesPage } from '@/features/jobs/components/job-templates-page'

export const Route = createFileRoute('/_app/_auth/dashboard/_layout/templates')(
  {
    component: JobTemplatesPage,
    beforeLoad: () => ({
      title: 'Templates',
      headerTitleKey: 'header.templates.title',
      headerDescriptionKey: 'header.templates.description',
    }),
  },
)
